import { Injectable } from "@angular/core";
import { ApiService } from "@app/gateway/services/api.service";
import { AuthService } from "@app/gateway/services/auth.service";
import {fromEvent, BehaviorSubject, of, Subject } from "rxjs";
import { takeUntil, switchMap } from "rxjs/operators";
import { HttpHeaders } from '@angular/common/http';
import { ServiceConfigService } from '@app/services/service-config.service';
import { GoogleAnalyticsService } from "@app/services/analytics/analytics.service";
import { Router } from '@angular/router';
import { CookieService  } from "ngx-cookie-service";
import { isNilOrEmpty } from "ramda-adjunct";
import { ChatbotComponent } from '@app/components/chatbot/chatbot.component';
import { UserProfileService } from "../user-profile/user-profile.service";
declare let gtag: Function;
@Injectable()
export class SigninService {
  getAccountDataSubject = new Subject<any>();
  accountData = this.getAccountDataSubject.asObservable();
  getIndivId = new BehaviorSubject<string>("")
  indivId = this.getIndivId.asObservable();
  userLoggedIn = new BehaviorSubject<boolean>(false);
  private destroy$ = new Subject<void>();
  tcamKey:string;
  userType;
  oldtcam;
  // @ts-ignore
  constructor(private apiService: ApiService, private router: Router, private authService: AuthService, private serverConfig: ServiceConfigService, public analytics: GoogleAnalyticsService, private cookieService: CookieService, public userProfileService: UserProfileService) {
    this.tcamKey = this.serverConfig.getServerConfig().TCAM_KEY;
    this.startListeningForStorageEvents();
  }

  signIn(userId: string) {
    if (userId) {
      const url = 'publ/signin/validate?userId=' + userId;
      return this.apiService.get(url, null, {headers: new HttpHeaders({'pageId': 'TCLGN', 'sessionId': this.getSessionId()})});
    }
    return of(null);
  }

   getCookie(name) {
    const cookieArr = document.cookie.split(";");
    for (let i = 0; i < cookieArr.length; i++) {
      const cookiePair = cookieArr[i].split("=");
      if (name === cookiePair[0].trim()) {
        return decodeURIComponent(cookiePair[1]);
      }
    }
    return null;
  }

  private startListeningForStorageEvents(): void {
    fromEvent<StorageEvent>(window, 'storage')
      .pipe(takeUntil(this.destroy$))
      .subscribe((event: StorageEvent) => {
        if (event.storageArea === localStorage) {
          // Check if a different user has logged in or a logout event occurred
          if (event.key === 'ulgTimestamp' && event.newValue !== null) {
            // Different user logged in, force logout
            const url = 'indi/signout';
            this.userType = sessionStorage.getItem('userType');
            if (this.userType === 'RP') {
              this.oldtcam = this.getCookie(this.tcamKey);
            } else {
              this.oldtcam = sessionStorage.getItem('tcam');
            }
            if (this.oldtcam) {
              const headers = new HttpHeaders({ Authorization: this.authService.tokenId, 'pageId': 'TCLGT' });
              this.apiService.post(url, { 'tcam': this.oldtcam }, { headers }).subscribe();
              this.signOut(false);
              gtag('set', {'user_id': null});
              this.router.navigateByUrl('/logout');
              if (ChatbotComponent.chatbotInstance) {
                 ChatbotComponent.chatbotInstance.destroy();
             }
              let globalLang = sessionStorage.getItem('globalTranslatedLan')
              sessionStorage.clear();
              sessionStorage.setItem('isLogout', 'true');
              this.setGlobalLang(globalLang)
            }
          }
        }
      });
  }

  setGlobalLang(globalLang) {
    if (globalLang) {
      sessionStorage.setItem('globalTranslatedLan', globalLang);
    }
  }

  validate(user) {
    const contentHeader = new HttpHeaders({ "Content-Type": "application/json", "pageId": "TCLGN", 'sessionId': this.getSessionId()});
    const url = 'publ/users/loginUser';
    return this.apiService.post(url, user, { headers: contentHeader, observe: 'response' }).pipe(switchMap((res: any) => {
      sessionStorage.setItem('userName', user.userName);
      if (!res.body['message']) {
      const authToken = res.headers.get('x-auth-token');
      this.authService.setToken(authToken);
        if (this.cookieService.check(this.tcamKey)) {
          this.cookieService.delete(this.tcamKey, '/', '.tn.gov')
          this.cookieService.delete(this.tcamKey, '/', window.location.hostname)
        }
        this.cookieService.set(this.tcamKey, res.headers.get('tcam'), undefined, '/', window.location.hostname, true, 'None')
      const tcam = res.headers.get('tcam');
      sessionStorage.setItem('tcam', tcam);
      return this.getAccountData (user.userName).pipe(switchMap(data => {
        if (data) {
          this.analytics.setCurrentUser(data['userId']);
          sessionStorage.setItem('userName', data['userId']);
          sessionStorage.setItem('currentUser', JSON.stringify(data));
          sessionStorage.setItem('individualId', data['indvId']);
          sessionStorage.setItem('firstTimeAccessSw', data['firstTimeAccessSw']);
          sessionStorage.setItem('ridpSwitch', data['ridpverfStatusCd']);
          data['ridpverfStatusTimeStamp']? sessionStorage.setItem('ridpTimestamp', data['ridpverfStatusTimeStamp']): null;
          data['ridpHubrefNum'] ? sessionStorage.setItem('ridpHubRefNum', data['ridpHubrefNum']): null;
          data['ridpDocVerfSw'] ? sessionStorage.setItem('documentStatus', data['ridpDocVerfSw']): null;
          data['rIDPSubmissionCounter'] ? sessionStorage.setItem('ridpSubmissionCount', data['rIDPSubmissionCounter']): null;
          this.userLoggedIn.next(true);
          this.getAccountDataSubject.next(data);
          if(data['userSrcCd'] === "EB") {
            this.analytics.setEbmsFlag();
          }
        }
        return of(null)
      }))
  } else {
    const errorMessage = res.body['message'];
      this.userLoggedIn.next(false);
        return of(errorMessage)
      }
    }))
  }

  getAccountData (userId: String) {
    if (userId) {
      const encodeUserId = encodeURIComponent(userId.toString());
      const url = 'publ/signin/validate/info?userId=' + encodeUserId;
      return this.apiService.get(url, null, {headers: new HttpHeaders({'pageId': 'TCLGN', 'sessionId': this.getSessionId()})})
    }
    return of(null);
  }

  getCaseData (accountType, caseNum, user) {
    const url = 'indi/atglance?accountType=' + accountType + '&caseNumber=' + caseNum + '&userId=' + user.userId;
    return this.apiService.get(url, null, {headers: new HttpHeaders({'pageId': 'TCLGN', 'sessionId': this.getSessionId()})});
  }

  signOut (bool) {
    this.userLoggedIn.next(bool);
  }

  getSessionId(): string {
      const tcamKey = this.serverConfig.getServerConfig().TCAM_KEY;
      const sessionId = isNilOrEmpty(this.userProfileService.getCookie(tcamKey)) ? sessionStorage.getItem('tcam') : this.userProfileService.getCookie(tcamKey);
      return sessionId ?? '';
  }
}